import { useState } from 'react'

import DashboardMap from './dashboard-googlemap.container'
import DashboardJetty from './dashboard-jetty.container'
import DashboardBerthingManagement from './dashboard-berthing-management'
import DashboardVesselTrafficInformation from './dashboard-vessel-traffic-information'

import { Nav, MenuWrapper, MenuList, ContentList } from './dashboard.styled'

const Dashboard = () => {
  const [activeDashboard, setActiveDashboard] = useState('maps')

  const dashboardMenus = [
    { id: 'maps', label: 'Maps' },
    { id: 'jetty', label: 'Maps Jetty' },
    { id: 'berthing-management', label: 'Berthing Management' },
    { id: 'vessel-traffic-information', label: 'Vessel Traffic Information' },
  ]

  return (
    <main>
      <Nav>
        <MenuWrapper>
          {dashboardMenus.map((menu) => (
            <MenuList
              key={menu.id}
              active={activeDashboard === menu.id}
              onClick={() => setActiveDashboard(menu.id)}
              id={`dsb-menu-${menu.id}-btn`}
            >
              {menu.label}
            </MenuList>
          ))}
        </MenuWrapper>
      </Nav>
      <div>
        <ContentList active={true}>
          {activeDashboard === 'maps' && <DashboardMap />}
          {activeDashboard === 'jetty' && <DashboardJetty />}
          {activeDashboard === 'berthing-management' && <DashboardBerthingManagement />}
          {activeDashboard === 'vessel-traffic-information' && <DashboardVesselTrafficInformation />}
        </ContentList>
      </div>
    </main>
  )
}

export default Dashboard
